export const INSUFFICIENT_STOCK = 'INSUFFICIENT_STOCK';
export const ORDER_ERROR_TITLE = 'This order cannot be completed';
export const INSUFFICIENT_STOCK_MESSAGE =
  'There is an out-of-stock item in your order. Your order cannot be completed. Please contact us at orders@christiecookies.com | 1-800-458-2447';
